export default async function searchRESTApi( {searchString, signal} : {searchString: string, signal: AbortSignal} ) {
    
    // Fetch menu data from REST API

    if( !searchString?.length || searchString.length === 0 ) return null;

    if( !signal ){
        const controller = new AbortController();
        signal = controller.signal;
    }
    try{

            const response = await fetch(`/wp-json/wp/v2/search?search=${searchString}&type=post&subtype=post,page,adweek_event`, {
                signal: signal
            });
            const data = await response.json();
            const totalPagesHeader = response.headers.get('X-WP-TotalPages');
            const totalPages = Number(totalPagesHeader || 0);

            console.log( 'searchRESTApi', data );
            return {
                results: data,
                totalPages: Number.isFinite(totalPages) ? totalPages : 0,
            };
        
    } catch (error) {
        // If the error is an abort error, we can ignore it as it's expected when the request is cancelled
        if (error?.name === 'AbortError') {
            console.log('Search request was aborted');
            return null;
        }
        console.error('Error fetching search data', error);
        return null;
    }
    
}